import React from "react";
import { ADDITIONAL_PROPERTY_FLAG, TranslatableString, } from "@rjsf/utils";
export default function WrapIfAdditionalTemplate({ classNames, style, children, disabled, id, label, onDropPropertyClick, onKeyChange, readonly, required, schema, uiSchema, registry, }) {
    const { templates, translateString } = registry;
    // Button templates are not overridden in the uiSchema
    const { RemoveButton } = templates.ButtonTemplates;
    const keyLabel = translateString(TranslatableString.KeyLabel, [label]);
    const additional = ADDITIONAL_PROPERTY_FLAG in schema;
    if (!additional) {
        return (React.createElement("div", { className: classNames, style: style }, children));
    }
    const handleBlur = ({ target }) => onKeyChange(target.value);
    const keyId = `${id}-key`;
    return (React.createElement("div", { className: `flex ${classNames}`, style: style },
        React.createElement("div", { className: "w-1/2 flex-none p-2" },
            React.createElement("label", { htmlFor: keyId, className: "block text-sm font-medium text-muted-foreground" }, keyLabel),
            React.createElement("input", { required: required, defaultValue: label, disabled: disabled || readonly, id: keyId, name: keyId, onBlur: !readonly ? handleBlur : undefined, type: "text", className: "mt-1 w-full border p-2 shadow-sm" })),
        React.createElement("div", { className: "w-1/2 flex-none p-2" }, children),
        React.createElement("div", { className: "w-1/4 flex-none p-2" },
            React.createElement(RemoveButton, { iconType: "block", className: "w-full", disabled: disabled || readonly, onClick: onDropPropertyClick(label), uiSchema: uiSchema, registry: registry }))));
}
//# sourceMappingURL=WrapIfAdditionalTemplate.js.map